// // // // // // import React, { useState } from 'react';
// // // // // // import { Box, Button, IconButton, Typography, TextField } from '@mui/material';
// // // // // // import DeleteIcon from '@mui/icons-material/Delete';

// // // // // // const ImageUploadField = ({ label, image, onChange, onDelete }) => {
// // // // // //   const handleImageChange = (e) => {
// // // // // //     const file = e.target.files[0];
// // // // // //     if (file) {
// // // // // //       const imageUrl = URL.createObjectURL(file);
// // // // // //       onChange(imageUrl, file);
// // // // // //     }
// // // // // //   };

// // // // // //   return (
// // // // // //     <Box sx={{ mb: 3 }}>
// // // // // //       <Typography variant="subtitle1">{label}</Typography>
// // // // // //       <input
// // // // // //         accept="image/*"
// // // // // //         type="file"
// // // // // //         onChange={handleImageChange}
// // // // // //         style={{ marginTop: '8px' }}
// // // // // //       />
// // // // // //       {image && (
// // // // // //         <Box mt={1} sx={{ position: 'relative', display: 'inline-block' }}>
// // // // // //           <img
// // // // // //             src={image}
// // // // // //             alt={label}
// // // // // //             style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 8 }}
// // // // // //           />
// // // // // //           <IconButton
// // // // // //             onClick={onDelete}
// // // // // //             size="small"
// // // // // //             sx={{ position: 'absolute', top: 0, right: 0, bgcolor: 'white' }}
// // // // // //           >
// // // // // //             <DeleteIcon fontSize="small" />
// // // // // //           </IconButton>
// // // // // //         </Box>
// // // // // //       )}
// // // // // //     </Box>
// // // // // //   );
// // // // // // };

// // // // // // const BrandingSettings = () => {
// // // // // //   const [primaryColor, setPrimaryColor] = useState('#0011FF');
// // // // // //   const [logo, setLogo] = useState('http://localhost:5000/api/v1/myg.png');
// // // // // //   const [favicon, setFavicon] = useState('http://localhost:5000/api/v1/myg.ico');
// // // // // //   const [bannerImage, setBannerImage] = useState('http://localhost:5000/api/v1/myg.png');

// // // // // //   return (
// // // // // //     <Box sx={{ p: 3, maxWidth: 400 }}>
// // // // // //       <Typography variant="h5" gutterBottom>
// // // // // //         Branding Settings
// // // // // //       </Typography>

// // // // // //       {/* Primary Color Picker */}
// // // // // //       <Box sx={{ mb: 3 }}>
// // // // // //         <Typography variant="subtitle1">Primary Color</Typography>
// // // // // //         <input
// // // // // //           type="color"
// // // // // //           value={primaryColor}
// // // // // //           onChange={(e) => setPrimaryColor(e.target.value)}
// // // // // //           style={{ width: '100%', height: '40px', border: 'none' }}
// // // // // //         />
// // // // // //         <TextField
// // // // // //           fullWidth
// // // // // //           variant="outlined"
// // // // // //           value={primaryColor}
// // // // // //           onChange={(e) => setPrimaryColor(e.target.value)}
// // // // // //           sx={{ mt: 1 }}
// // // // // //         />
// // // // // //       </Box>

// // // // // //       {/* Logo Upload */}
// // // // // //       <ImageUploadField
// // // // // //         label="Logo"
// // // // // //         image={logo}
// // // // // //         onChange={(url) => setLogo(url)}
// // // // // //         onDelete={() => setLogo(null)}
// // // // // //       />

// // // // // //       {/* Favicon Upload */}
// // // // // //       <ImageUploadField
// // // // // //         label="Favicon"
// // // // // //         image={favicon}
// // // // // //         onChange={(url) => setFavicon(url)}
// // // // // //         onDelete={() => setFavicon(null)}
// // // // // //       />

// // // // // //       {/* Banner Image Upload */}
// // // // // //       <ImageUploadField
// // // // // //         label="Banner Image"
// // // // // //         image={bannerImage}
// // // // // //         onChange={(url) => setBannerImage(url)}
// // // // // //         onDelete={() => setBannerImage(null)}
// // // // // //       />

// // // // // //       <Button variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
// // // // // //         Save Settings
// // // // // //       </Button>
// // // // // //     </Box>
// // // // // //   );
// // // // // // };

// // // // // // export default BrandingSettings;


// // // // // import React, { useState } from 'react';
// // // // // import {
// // // // //   Box,
// // // // //   Button,
// // // // //   IconButton,
// // // // //   Typography,
// // // // //   TextField
// // // // // } from '@mui/material';
// // // // // import DeleteIcon from '@mui/icons-material/Delete';
// // // // // import { toast, ToastContainer } from 'react-toastify';
// // // // // import 'react-toastify/dist/ReactToastify.css';

// // // // // const validateImage = (file, type, callback) => {
// // // // //   const img = new Image();
// // // // //   img.src = URL.createObjectURL(file);
// // // // //   img.onload = () => {
// // // // //     const { width, height } = img;

// // // // //     if (type === !'favicon'
// // // // //         //  && (width !== 32 || height !== 32)
// // // // //         ) {
// // // // //       toast.error('Favicon must be exactly 32x32 pixels.');
// // // // //       return;
// // // // //     }

// // // // //     if (type === 'logo') {
// // // // //       if (file.type !== 'image/png') {
// // // // //         toast.error('Logo must be a PNG image.');
// // // // //         return;
// // // // //       }
// // // // //     //   if (height !== 100 || width < 250 || width > 400) {
// // // // //     //     toast.error('Logo must be between 250x100 and 400x100 pixels.');
// // // // //     //     return;
// // // // //     //   }
// // // // //     }

// // // // //     if (type === !'banner'
// // // // //         //  && (width !== 1200 || height !== 400)
// // // // //         ) {
// // // // //       toast.error('Banner must be exactly 1200x400 pixels.');
// // // // //       return;
// // // // //     }

// // // // //     const imageUrl = URL.createObjectURL(file);
// // // // //     callback(imageUrl, file);
// // // // //   };
// // // // // };

// // // // // const ImageUploadField = ({ label, image, onChange, onDelete, type }) => {
// // // // //   const handleImageChange = (e) => {
// // // // //     const file = e.target.files[0];
// // // // //     if (!file) return;
// // // // //     validateImage(file, type, onChange);
// // // // //   };

// // // // //   return (
// // // // //     <Box sx={{ mb: 3 }}>
// // // // //       <Typography variant="subtitle1">{label}</Typography>
// // // // //       <input
// // // // //         accept="image/*"
// // // // //         type="file"
// // // // //         onChange={handleImageChange}
// // // // //         style={{ marginTop: '8px' }}
// // // // //       />
// // // // //       {image && (
// // // // //         <Box mt={1} sx={{ position: 'relative', display: 'inline-block' }}>
// // // // //           <img
// // // // //             src={image}
// // // // //             alt={label}
// // // // //             style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 8 }}
// // // // //           />
// // // // //           <IconButton
// // // // //             onClick={onDelete}
// // // // //             size="small"
// // // // //             sx={{ position: 'absolute', top: 0, right: 0, bgcolor: 'white' }}
// // // // //           >
// // // // //             <DeleteIcon fontSize="small" />
// // // // //           </IconButton>
// // // // //         </Box>
// // // // //       )}
// // // // //     </Box>
// // // // //   );
// // // // // };

// // // // // const BrandingSettings = () => {
// // // // //   const [primaryColor, setPrimaryColor] = useState('#0011FF');
// // // // //   const [logo, setLogo] = useState('http://localhost:5000/api/v1/myg.png');
// // // // //   const [favicon, setFavicon] = useState('http://localhost:5000/api/v1/myg.ico');
// // // // //   const [bannerImage, setBannerImage] = useState('http://localhost:5000/api/v1/myg.png');

// // // // //   return (
// // // // //     <Box sx={{ p: 3, maxWidth: 400 }}>
// // // // //       <ToastContainer position="top-right" autoClose={3000} />
// // // // //       <Typography variant="h5" gutterBottom>
// // // // //         Branding Settings
// // // // //       </Typography>

// // // // //       {/* Primary Color Picker */}
// // // // //       <Box sx={{ mb: 3 }}>
// // // // //         <Typography variant="subtitle1">Primary Color</Typography>
// // // // //         <input
// // // // //           type="color"
// // // // //           value={primaryColor}
// // // // //           onChange={(e) => setPrimaryColor(e.target.value)}
// // // // //           style={{ width: '100%', height: '40px', border: 'none' }}
// // // // //         />
// // // // //         <TextField
// // // // //           fullWidth
// // // // //           variant="outlined"
// // // // //           value={primaryColor}
// // // // //           onChange={(e) => setPrimaryColor(e.target.value)}
// // // // //           sx={{ mt: 1 }}
// // // // //         />
// // // // //       </Box>

// // // // //       {/* Logo Upload */}
// // // // //       <ImageUploadField
// // // // //         label="Logo"
// // // // //         type="logo"
// // // // //         image={logo}
// // // // //         onChange={(url) => setLogo(url)}
// // // // //         onDelete={() => setLogo(null)}
// // // // //       />

// // // // //       {/* Favicon Upload */}
// // // // //       <ImageUploadField
// // // // //         label="Favicon"
// // // // //         type="favicon"
// // // // //         image={favicon}
// // // // //         onChange={(url) => setFavicon(url)}
// // // // //         onDelete={() => setFavicon(null)}
// // // // //       />

// // // // //       {/* Banner Image Upload */}
// // // // //       <ImageUploadField
// // // // //         label="Banner Image"
// // // // //         type="banner"
// // // // //         image={bannerImage}
// // // // //         onChange={(url) => setBannerImage(url)}
// // // // //         onDelete={() => setBannerImage(null)}
// // // // //       />

// // // // //       <Button variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
// // // // //         Save Settings
// // // // //       </Button>
// // // // //     </Box>
// // // // //   );
// // // // // };

// // // // // export default BrandingSettings;



// // // // import React, { useState } from 'react';
// // // // import {
// // // //   Box,
// // // //   Button,
// // // //   IconButton,
// // // //   Typography,
// // // //   TextField
// // // // } from '@mui/material';
// // // // import DeleteIcon from '@mui/icons-material/Delete';
// // // // import { toast, ToastContainer } from 'react-toastify';
// // // // import 'react-toastify/dist/ReactToastify.css';

// // // // // ✅ Image validation function
// // // // const validateImage = (file, type, callback) => {
// // // //   const img = new Image();
// // // //   img.src = URL.createObjectURL(file);
// // // //   img.onload = () => {
// // // //     const { width, height } = img;

// // // //     // if (type === 'favicon') {
// // // //     //   if (width !== 32 || height !== 32) {
// // // //     //     toast.error('Favicon must be exactly 32x32 pixels.');
// // // //     //     return;
// // // //     //   }
// // // //     // }

// // // //     if (type === 'logo') {
// // // //       if (file.type !== 'image/png') {
// // // //         toast.error('Logo must be a PNG image.');
// // // //         return;
// // // //       }
// // // //       if (height !== 100 || width < 250 || width > 400) {
// // // //         toast.error('Logo must be between 250x100 and 400x100 pixels.');
// // // //         return;
// // // //       }
// // // //     }

// // // //     if (type === 'banner') {
// // // //       if (width !== 1200 || height !== 400) {
// // // //         toast.error('Banner must be exactly 1200x400 pixels.');
// // // //         return;
// // // //       }
// // // //     }

// // // //     const imageUrl = img.src;
// // // //     callback(imageUrl, file);
// // // //   };
// // // // };

// // // // // ✅ Dynamic Favicon Updater
// // // // const updateFavicon = (url) => {
// // // //   let link = document.querySelector("link[rel~='icon']");

// // // //   if (!link) {
// // // //     link = document.createElement('link');
// // // //     link.rel = 'icon';
// // // //     document.head.appendChild(link);
// // // //   }

// // // //   link.href = url || '';
// // // // };

// // // // const ImageUploadField = ({ label, image, onChange, onDelete, type }) => {
// // // //   const handleImageChange = (e) => {
// // // //     const file = e.target.files[0];
// // // //     if (!file) return;
// // // //     validateImage(file, type, onChange);
// // // //   };

// // // //   return (
// // // //     <Box sx={{ mb: 3 }}>
// // // //       <Typography variant="subtitle1">{label}</Typography>
// // // //       <input
// // // //         accept="image/*"
// // // //         type="file"
// // // //         onChange={handleImageChange}
// // // //         style={{ marginTop: '8px' }}
// // // //       />
// // // //       {image && (
// // // //         <Box mt={1} sx={{ position: 'relative', display: 'inline-block' }}>
// // // //           <img
// // // //             src={image}
// // // //             alt={label}
// // // //             style={{ width: 100, height: 100, objectFit: 'cover', borderRadius: 8 }}
// // // //           />
// // // //           <IconButton
// // // //             onClick={onDelete}
// // // //             size="small"
// // // //             sx={{ position: 'absolute', top: 0, right: 0, bgcolor: 'white' }}
// // // //           >
// // // //             <DeleteIcon fontSize="small" />
// // // //           </IconButton>
// // // //         </Box>
// // // //       )}
// // // //     </Box>
// // // //   );
// // // // };

// // // // const BrandingSettings = () => {
// // // //   const [primaryColor, setPrimaryColor] = useState('#0011FF');
// // // //   const [logo, setLogo] = useState('http://localhost:5000/api/v1/myg.png');
// // // //   const [favicon, setFavicon] = useState('http://localhost:5000/api/v1/myg.ico');
// // // //   const [bannerImage, setBannerImage] = useState('http://localhost:5000/api/v1/myg.png');

// // // //   return (
// // // //     <Box sx={{ p: 3, maxWidth: 400 }}>
// // // //       <ToastContainer position="top-right" autoClose={3000} />
// // // //       <Typography variant="h5" gutterBottom>
// // // //         Branding Settings
// // // //       </Typography>

// // // //       {/* Primary Color Picker */}
// // // //       <Box sx={{ mb: 3 }}>
// // // //         <Typography variant="subtitle1">Primary Color</Typography>
// // // //         <input
// // // //           type="color"
// // // //           value={primaryColor}
// // // //           onChange={(e) => setPrimaryColor(e.target.value)}
// // // //           style={{ width: '100%', height: '40px', border: 'none' }}
// // // //         />
// // // //         <TextField
// // // //           fullWidth
// // // //           variant="outlined"
// // // //           value={primaryColor}
// // // //           onChange={(e) => setPrimaryColor(e.target.value)}
// // // //           sx={{ mt: 1 }}
// // // //         />
// // // //       </Box>

// // // //       {/* Logo Upload */}
// // // //       <ImageUploadField
// // // //         label="Logo"
// // // //         type="logo"
// // // //         image={logo}
// // // //         onChange={(url) => setLogo(url)}
// // // //         onDelete={() => setLogo(null)}
// // // //       />

// // // //       {/* Favicon Upload */}
// // // //       <ImageUploadField
// // // //         label="Favicon"
// // // //         type="favicon"
// // // //         image={favicon}
// // // //         onChange={(url) => {
// // // //           setFavicon(url);
// // // //           updateFavicon(url);
// // // //         }}
// // // //         onDelete={() => {
// // // //           setFavicon(null);
// // // //           updateFavicon(null);
// // // //         }}
// // // //       />

// // // //       {/* Banner Image Upload */}
// // // //       <ImageUploadField
// // // //         label="Banner Image"
// // // //         type="banner"
// // // //         image={bannerImage}
// // // //         onChange={(url) => setBannerImage(url)}
// // // //         onDelete={() => setBannerImage(null)}
// // // //       />

// // // //       <Button variant="contained" color="primary" fullWidth sx={{ mt: 2 }}>
// // // //         Save Settings
// // // //       </Button>
// // // //     </Box>
// // // //   );
// // // // };

// // // // export default BrandingSettings;

// // // import {
// // //     Dialog,
// // //     DialogTitle,
// // //     DialogContent,
// // //     DialogActions,
// // //     Button,
// // //     Tabs,
// // //     Tab,
// // //     Box,
// // //     Typography,
// // //     TextField,
// // //     IconButton,
// // //     InputAdornment,
// // // } from '@mui/material';
// // // import PhotoCamera from '@mui/icons-material/PhotoCamera';
// // // import { SketchPicker } from 'react-color';
// // // import { useState } from 'react';

// // // const TabPanel = ({ children, value, index }) => (
// // //     <div hidden={value !== index}>
// // //         {value === index && <Box sx={{ mt: 2 }}>{children}</Box>}
// // //     </div>
// // // );

// // // const BrandingSettings = () => {
// // //     const [tab, setTab] = useState(0);
// // //     const [logo, setLogo] = useState(null);
// // //     const [favicon, setFavicon] = useState(null);
// // //     const [themeColor, setThemeColor] = useState('#1976d2');
// // //     const [appName, setAppName] = useState('');

// // //     const handleImageChange = (e, setter) => {
// // //         const file = e.target.files[0];
// // //         if (file) {
// // //             setter(URL.createObjectURL(file));
// // //         }
// // //     };

// // //     const handleSave = () => {
// // //         console.log({ logo, favicon, themeColor, appName });

// // //     };
// // //     return (
// // //         <Box>
// // //             <Tabs value={tab} onChange={(e, val) => setTab(val)} centered>
// // //                 <Tab label="Logo" />
// // //                 <Tab label="Theme Color" />
// // //                 <Tab label="Favicon" />
// // //                 <Tab label="App Name" />
// // //             </Tabs>

// // //             <TabPanel value={tab} index={0}>
// // //                 <Typography>Upload Logo</Typography>
// // //                 <Button
// // //                     variant="contained"
// // //                     component="label"
// // //                     startIcon={<PhotoCamera />}
// // //                     sx={{ mt: 2 }}
// // //                 >
// // //                     Upload
// // //                     <input type="file" hidden onChange={(e) => handleImageChange(e, setLogo)} />
// // //                 </Button>
// // //                 {logo && (
// // //                     <Box mt={2}>
// // //                         <Typography variant="body2">Preview:</Typography>
// // //                         <img src={logo} alt="Logo Preview" width="100" />
// // //                     </Box>
// // //                 )}
// // //             </TabPanel>

// // //             <TabPanel value={tab} index={1}>
// // //                 <Typography>Select Theme Color</Typography>
// // //                 <Box mt={2}>
// // //                     <SketchPicker
// // //                         color={themeColor}
// // //                         onChangeComplete={(color) => setThemeColor(color.hex)}
// // //                     />
// // //                 </Box>
// // //             </TabPanel>

// // //             <TabPanel value={tab} index={2}>
// // //                 <Typography>Upload Favicon</Typography>
// // //                 <Button
// // //                     variant="contained"
// // //                     component="label"
// // //                     startIcon={<PhotoCamera />}
// // //                     sx={{ mt: 2 }}
// // //                 >
// // //                     Upload
// // //                     <input type="file" hidden onChange={(e) => handleImageChange(e, setFavicon)} />
// // //                 </Button>
// // //                 {favicon && (
// // //                     <Box mt={2}>
// // //                         <Typography variant="body2">Preview:</Typography>
// // //                         <img src={favicon} alt="Favicon Preview" width="32" height="32" />
// // //                     </Box>
// // //                 )}
// // //             </TabPanel>

// // //             <TabPanel value={tab} index={3}>
// // //                 <TextField
// // //                     label="App Name"
// // //                     variant="outlined"
// // //                     fullWidth
// // //                     value={appName}
// // //                     onChange={(e) => setAppName(e.target.value)}
// // //                     sx={{ mt: 2 }}
// // //                 />
// // //             </TabPanel>
// // //         </Box>

// // //     );
// // // };

// // // export default BrandingSettings;


// // import {
// //     Box,
// //     Typography,
// //     Button,
// //     TextField,
// // } from '@mui/material';
// // import PhotoCamera from '@mui/icons-material/PhotoCamera';
// // import { SketchPicker } from 'react-color';
// // import { useState } from 'react';

// // const BrandingSettings = () => {
// //     const [logo, setLogo] = useState(null);
// //     const [favicon, setFavicon] = useState(null);
// //     const [themeColor, setThemeColor] = useState('#1976d2');
// //     const [appName, setAppName] = useState('');

// //     const handleImageChange = (e, setter) => {
// //         const file = e.target.files[0];
// //         if (file) {
// //             setter(URL.createObjectURL(file));
// //         }
// //     };

// //     const handleSave = () => {
// //         console.log({ logo, favicon, themeColor, appName });
// //     };

// //     return (
// //         <Box>
// //             {/* Logo Upload */}
// //             <Typography variant="h6">Upload Logo</Typography>
// //             <Button
// //                 variant="contained"
// //                 component="label"
// //                 startIcon={<PhotoCamera />}
// //                 sx={{ mt: 2 }}
// //             >
// //                 Upload
// //                 <input type="file" hidden onChange={(e) => handleImageChange(e, setLogo)} />
// //             </Button>
// //             {logo && (
// //                 <Box mt={2}>
// //                     <Typography variant="body2">Preview:</Typography>
// //                     <img src={logo} alt="Logo Preview" width="100" />
// //                 </Box>
// //             )}

// //             {/* Favicon Upload */}
// //             <Typography variant="h6" sx={{ mt: 4 }}>Upload Favicon</Typography>
// //             <Button
// //                 variant="contained"
// //                 component="label"
// //                 startIcon={<PhotoCamera />}
// //                 sx={{ mt: 2 }}
// //             >
// //                 Upload
// //                 <input type="file" hidden onChange={(e) => handleImageChange(e, setFavicon)} />
// //             </Button>
// //             {favicon && (
// //                 <Box mt={2}>
// //                     <Typography variant="body2">Preview:</Typography>
// //                     <img src={favicon} alt="Favicon Preview" width="32" height="32" />
// //                 </Box>
// //             )}

// //              {/* Favicon Upload */}
// //             <Typography variant="h6" sx={{ mt: 4 }}>Upload Banner</Typography>
// //             <Button
// //                 variant="contained"
// //                 component="label"
// //                 startIcon={<PhotoCamera />}
// //                 sx={{ mt: 2 }}
// //             >
// //                 Upload
// //                 <input type="file" hidden onChange={(e) => handleImageChange(e, setFavicon)} />
// //             </Button>
// //             {favicon && (
// //                 <Box mt={2}>
// //                     <Typography variant="body2">Preview:</Typography>
// //                     <img src={favicon} alt="Favicon Preview" width="32" height="32" />
// //                 </Box>
// //             )}

// //             {/* Theme Color Picker */}
// //             <Typography variant="h6" sx={{ mt: 4 }}>Select Theme Color</Typography>
// //             <Box mt={2}>
// //                 <SketchPicker
// //                     color={themeColor}
// //                     onChangeComplete={(color) => setThemeColor(color.hex)}
// //                 />
// //             </Box>



// //             {/* Save Button */}
// //             <Button variant="contained" color="primary" onClick={handleSave} sx={{ mt: 4 }}>
// //                 Save Settings
// //             </Button>
// //         </Box>
// //     );
// // };

// // export default BrandingSettings;


// import {
//     Box,
//     Typography,
//     Button,
//     TextField,
//     Grid,
// } from '@mui/material';
// import PhotoCamera from '@mui/icons-material/PhotoCamera';
// import { SketchPicker } from 'react-color';
// import { useState } from 'react';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import actions from '../../ReduxStore/actions';
// import { useDispatch } from 'react-redux';


// const BrandingSettings = () => {
//     const [logo, setLogo] = useState(null);
//     const [favicon, setFavicon] = useState(null);
//     const [banner, setBanner] = useState(null); // Added banner state
//     const [themeColor, setThemeColor] = useState('#1976d2');
//     const [appName, setAppName] = useState(''); 
//     const dispatch =useDispatch()

//     const handleFileChange = async (event, setFieldValue) => {


//             const file = event.currentTarget.files[0];
//             if (file) {
//                 // const previewUrl = URL.createObjectURL(file);
//                 const formData = new FormData();

//                 formData.append("uploadFiles", file); // same key used multiple times


//                 const data1 = {
//                     data: formData,
//                     method: "post",
//                     apiName: "uploadImage",
//                 };

//                 try {
//                     const response = await dispatch(actions.UPLOADIMAGE(data1));
//                     console.log(response, "uploadPdfAndImageResponse");
//                     setFieldValue("image", response?.payload?.data?.files[0]?.fileUrl);

//                     // setPreviewUrl(response?.payload?.data?.files[0]?.fileUrl);
//                 } catch (error) {
//                     console.error("Upload failed:", error);
//                 }
//                 // setViewImgApi(previewUrl);
//                 // setFieldValue(name, file); // Or set the URL here if uploading to backend
//             }
//         };


//     const handleImageChange = (e, setter) => {
//         const file = e.target.files[0];
//         if (file) {
//             setter(URL.createObjectURL(file));
//         }
//     };

//     const handleSave = () => {
//         console.log({ logo, favicon, banner, themeColor, appName });
//     };

//     return (
//         <Box sx={{ p: 6 }}>
//             {/* Logo Upload */}
//             <Grid container spacing={2} sx={{ border: "1px solid lightgray" }}>
//                 <Grid size={{ xs: 12, md: 6 }} sx={{ boxShadow: 4, p: 4 }}>

//                     <Typography variant="h6" sx={{ textAlign: "center", mb: 2 }}>Upload Logo (.png only)</Typography>
//                     {/* <Button
//                         variant="contained"
//                         component="label"
//                         startIcon={<PhotoCamera />}
//                         sx={{ mt: 2 }}
//                     >
//                         Upload Logo
//                         <input
//                             type="file"
//                             accept=".png"
//                             hidden
//                             onChange={(e) => handleImageChange(e, setLogo)}
//                         />
//                     </Button> */}
//                     <Box
//                         sx={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             alignItems: 'center'
//                         }}
//                     >

//                         <Button
//                             component="label"
//                             variant="outlined"
//                             sx={{
//                                 display: 'flex',
//                                 flexDirection: 'column',
//                                 alignItems: 'center',
//                                 py: 4,
//                                 px: 6,
//                                 // width: "50px",
//                                 borderRadius: 2,
//                                 borderStyle: 'dashed',
//                                 borderColor: 'gray',
//                                 bgcolor: '#fff',
//                                 cursor: 'pointer',
//                                 textTransform: 'none',
//                                 '&:hover': {
//                                     borderColor: 'primary.main',
//                                     bgcolor: '#f0f0f0',
//                                 },
//                             }}
//                         >
//                             <CloudUploadIcon sx={{ fontSize: 80, color: 'var(--main-color)' }} />
//                             {/* <Typography variant="h6" mt={1}>
//                             Upload Image
//                         </Typography> */}
//                             <input
//                                 type="file"
//                                 accept=".png"
//                                 hidden
//                                 onChange={(e) => handleImageChange(e, setLogo)}
//                             />
//                         </Button>
//                     </Box>
//                     {logo && (
//                         <Box mt={2}>
//                             <Typography variant="body2" sx={{ mb: 2 }}>Preview:</Typography>
//                             <img src={logo} alt="Logo Preview" width="100" />
//                         </Box>
//                     )}
//                 </Grid>
//                 <Grid size={{ xs: 12, md: 6 }} sx={{ boxShadow: 4, p: 4 }}>


//                     {/* Favicon Upload */}
//                     <Typography variant="h6" sx={{ textAlign: "center", mb: 2 }}>Upload Favicon (.ico only)</Typography>
//                     {/* <Button
//                         variant="contained"
//                         component="label"
//                         startIcon={<PhotoCamera />}
//                         sx={{ mt: 2 }}
//                     >
//                         Upload Favicon
//                         <input
//                             type="file"
//                             accept=".ico"
//                             hidden
//                             onChange={(e) => handleImageChange(e, setFavicon)}
//                         />
//                     </Button> */}
//                     <Box
//                         sx={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             alignItems: 'center'
//                         }}
//                     >

//                         <Button
//                             component="label"
//                             variant="outlined"
//                             sx={{
//                                 display: 'flex',
//                                 flexDirection: 'column',
//                                 alignItems: 'center',
//                                 py: 4,
//                                 px: 6,
//                                 // width: "50px",
//                                 borderRadius: 2,
//                                 borderStyle: 'dashed',
//                                 borderColor: 'gray',
//                                 bgcolor: '#fff',
//                                 cursor: 'pointer',
//                                 textTransform: 'none',
//                                 '&:hover': {
//                                     borderColor: 'primary.main',
//                                     bgcolor: '#f0f0f0',
//                                 },
//                             }}
//                         >
//                             <CloudUploadIcon sx={{ fontSize: 80, color: 'var(--main-color)' }} />
//                             {/* <Typography variant="h6" mt={1}>
//                             Upload Image
//                         </Typography> */}

//                             <input
//                                 type="file"
//                                 accept=".ico"
//                                 hidden
//                                 onChange={(e) => handleImageChange(e, setFavicon)}
//                             />
//                         </Button>
//                     </Box>
//                     {favicon && (
//                         <Box mt={2}>
//                             <Typography variant="body2" sx={{ mb: 2 }}>Preview:</Typography>
//                             <img src={favicon} alt="Favicon Preview" width="32" height="32" />
//                         </Box>
//                     )}
//                 </Grid>
//                 <Grid size={{ xs: 12, md: 6 }} sx={{ boxShadow: 4,p:4}}>


//                     {/* Banner Upload */}
//                     <Typography variant="h6" sx={{ textAlign: "center", mb: 2 }}>Upload Banner (image formats)</Typography>
//                     {/* <Button
//                         variant="contained"
//                         component="label"
//                         startIcon={<PhotoCamera />}
//                         sx={{ mt: 2 }}
//                     >
//                         Upload Banner
//                         <input
//                             type="file"
//                             accept="image/*"
//                             hidden
//                             onChange={(e) => handleImageChange(e, setBanner)}
//                         />
//                     </Button> */}
//                     <Box
//                         sx={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             alignItems: 'center'
//                         }}
//                     >

//                         <Button
//                             component="label"
//                             variant="outlined"
//                             sx={{
//                                 display: 'flex',
//                                 flexDirection: 'column',
//                                 alignItems: 'center',
//                                 py: 4,
//                                 px: 6,
//                                 // width: "50px",
//                                 borderRadius: 2,
//                                 borderStyle: 'dashed',
//                                 borderColor: 'gray',
//                                 bgcolor: '#fff',
//                                 cursor: 'pointer',
//                                 textTransform: 'none',
//                                 '&:hover': {
//                                     borderColor: 'primary.main',
//                                     bgcolor: '#f0f0f0',
//                                 },
//                             }}
//                         >
//                             <CloudUploadIcon sx={{ fontSize: 80, color: 'var(--main-color)' }} />
//                             {/* <Typography variant="h6" mt={1}>
//                             Upload Image
//                         </Typography> */}

//                             <input
//                                 type="file"
//                                 accept="image/*"
//                                 hidden
//                                 onChange={(e) => handleImageChange(e, setBanner)}
//                             />
//                         </Button>
//                     </Box>

//                     {banner && (
//                         <Box mt={2}>
//                             <Typography variant="body2" sx={{mb:2}}>Preview:</Typography>
//                             <img src={banner} alt="Banner Preview" width="100%" />
//                         </Box>
//                     )}
//                 </Grid>

//                 <Grid size={{ xs: 12, md: 6 }} sx={{ boxShadow: 4,p:4 }}>

//                     {/* App Name Input */}
//                     <Typography variant="h6" sx={{ mt: 4 }}>Application Name</Typography>
//                     <TextField
//                         fullWidth
//                         variant="outlined"
//                         placeholder="Enter app name"
//                         value={appName}
//                         onChange={(e) => setAppName(e.target.value)}
//                         sx={{ mt: 2 }}
//                     />

//                     {/* Theme Color Picker */}
//                     <Typography variant="h6" sx={{ mt: 4 }}>Select Theme Color</Typography>
//                     <Box mt={2}>
//                         <SketchPicker
//                             color={themeColor}
//                             onChangeComplete={(color) => setThemeColor(color.hex)}
//                         />
//                     </Box>
//                 </Grid>

//                 {/* Save Button */}
//                 <Button
//                     variant="contained"
//                     color="primary"
//                     onClick={handleSave}
//                     sx={{ mt: 4 }}
//                 >
//                     Save Settings
//                 </Button>
//             </Grid>
//         </Box >
//     );
// };

// export default BrandingSettings;


// import {
//     Box,
//     Typography,
//     Button,
//     TextField,
//     Grid,
// } from '@mui/material';
// import { useState } from 'react';
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
// import { SketchPicker } from 'react-color';
// import { useDispatch, useSelector } from 'react-redux';
// import { Formik, Form, Field } from 'formik';
// import actions from '../../ReduxStore/actions';
// import { adminUrl } from '../../constants';
// import { toast } from 'react-toastify';

// const BrandingSettings = () => {
//     const dispatch = useDispatch();
//     const [logoPreview, setLogoPreview] = useState(null);
//     const [faviconPreview, setFaviconPreview] = useState(null);
//     const [bannerPreview, setBannerPreview] = useState(null);

//     const handleFileChange = async (event, setFieldValue, fieldName, setPreview) => {
//         const file = event.currentTarget.files[0];
//         if (file) {
//             const formData = new FormData();
//             formData.append("uploadImage", file);

//             const data1 = {
//                 data: formData,
//                 method: "post",
//                 apiName: "uploadImage",
//             };

//             try {
//                 const response = await dispatch(actions.UPLOADIMAGE(data1));
//                 const fileUrl = response?.payload?.data?.imageUrl;
//                 setFieldValue(fieldName, fileUrl);
//                 setPreview(`${adminUrl}${response?.payload?.data?.imageUrl}`);
//             } catch (error) {
//                 console.error("Upload failed:", error);
//             }
//         }
//     };

//     const { getSiteSettings } = useSelector((state) => state?.getSiteSettings
//     );

// const handleSubmit = async (values, { resetForm }) => {
//     const data1 = {
//         data: {
//             primary_color: values?.themeColor,
//             logo: values?.logo,
//             favicon: values?.favicon,
//             banner_image: values?.banner,
//             company_name: values?.appName



//         },
//         method: "post",
//         apiName: `saveSiteSettings`
//     };
//     const response = await dispatch(actions.SAVESITESETINGS(data1));
//     console.log(response, "responsedataaaaaaa")
//     if (response?.payload?.message === "Site settings saved successfully.") {
//         toast?.success('Site settings saved successfully.')
//         setTimeout(() => {
//             resetForm()
//             // setUploadedFile(null)

//         }, 1500)
//     } else {
//         toast.error(response?.payload?.message)
//     }

// };

// return (
//     <Box sx={{ p: 6 }}>
//         <Formik
//             initialValues={{
//                 logo: '',
//                 favicon: '',
//                 banner: '',
//                 themeColor: '#1976d2',
//                 appName: ''
//             }}
//             onSubmit={handleSubmit}
//         >
//             {({ values, setFieldValue }) => (
//                 <Form>
//                     <Grid container spacing={2} sx={{ border: "1px solid lightgray" }}>

//                         {/* Logo Upload */}
//                         <Grid item size={{ xs: 12, md: 6 }} sx={{ boxShadow: 4, p: 4 }}>
//                             <Typography variant="h6" align="center" mb={2}>Upload Logo (.png only)</Typography>
//                             <Box display="flex" flexDirection="column" alignItems="center">
//                                 <Button
//                                     component="label"
//                                     variant="outlined"
//                                     sx={{
//                                         py: 4,
//                                         px: 6,
//                                         borderRadius: 2,
//                                         borderStyle: 'dashed',
//                                         borderColor: 'gray',
//                                         bgcolor: '#fff',
//                                         cursor: 'pointer',
//                                         textTransform: 'none',
//                                         '&:hover': {
//                                             borderColor: 'primary.main',
//                                             bgcolor: '#f0f0f0',
//                                         },
//                                     }}
//                                 >
//                                     <CloudUploadIcon sx={{ fontSize: 80 }} />
//                                     <input
//                                         type="file"
//                                         accept=".png"
//                                         hidden
//                                         onChange={(e) =>
//                                             handleFileChange(e, setFieldValue, 'logo', setLogoPreview)
//                                         }
//                                     />
//                                 </Button>
//                                 {logoPreview && (
//                                     <Box mt={2}>
//                                         <Typography variant="body2" mb={2}>Preview:</Typography>
//                                         <img src={logoPreview} alt="Logo Preview" width="100" />
//                                     </Box>
//                                 )}
//                             </Box>
//                         </Grid>

//                         {/* Favicon Upload */}
//                         <Grid item size={{ xs: 12, md: 6 }} sx={{ boxShadow: 4, p: 4 }}>
//                             <Typography variant="h6" align="center" mb={2}>Upload Favicon (.ico only)</Typography>
//                             <Box display="flex" flexDirection="column" alignItems="center">
//                                 <Button
//                                     component="label"
//                                     variant="outlined"
//                                     sx={{
//                                         py: 4,
//                                         px: 6,
//                                         borderRadius: 2,
//                                         borderStyle: 'dashed',
//                                         borderColor: 'gray',
//                                         bgcolor: '#fff',
//                                         cursor: 'pointer',
//                                         textTransform: 'none',
//                                         '&:hover': {
//                                             borderColor: 'primary.main',
//                                             bgcolor: '#f0f0f0',
//                                         },
//                                     }}
//                                 >
//                                     <CloudUploadIcon sx={{ fontSize: 80 }} />
//                                     <input
//                                         type="file"
//                                         accept=".ico"
//                                         hidden
//                                         onChange={(e) =>
//                                             handleFileChange(e, setFieldValue, 'favicon', setFaviconPreview)
//                                         }
//                                     />
//                                 </Button>
//                                 {faviconPreview && (
//                                     <Box mt={2}>
//                                         <Typography variant="body2" mb={2}>Preview:</Typography>
//                                         <img src={faviconPreview} alt="Favicon Preview" width="32" height="32" />
//                                     </Box>
//                                 )}
//                             </Box>
//                         </Grid>

//                         {/* Banner Upload */}
//                         <Grid item size={{ xs: 12, md: 6 }} sx={{ boxShadow: 4, p: 4 }}>
//                             <Typography variant="h6" align="center" mb={2}>Upload Banner (jpeg, jpg, png)</Typography>
//                             <Box display="flex" flexDirection="column" alignItems="center">
//                                 <Button
//                                     component="label"
//                                     variant="outlined"
//                                     sx={{
//                                         py: 4,
//                                         px: 6,
//                                         borderRadius: 2,
//                                         borderStyle: 'dashed',
//                                         borderColor: 'gray',
//                                         bgcolor: '#fff',
//                                         cursor: 'pointer',
//                                         textTransform: 'none',
//                                         '&:hover': {
//                                             borderColor: 'primary.main',
//                                             bgcolor: '#f0f0f0',
//                                         },
//                                     }}
//                                 >
//                                     <CloudUploadIcon sx={{ fontSize: 80 }} />
//                                     <input
//                                         type="file"
//                                         accept=".jpeg,.jpg,.png"
//                                         hidden
//                                         onChange={(e) =>
//                                             handleFileChange(e, setFieldValue, 'banner', setBannerPreview)
//                                         }
//                                     />
//                                 </Button>
//                                 {bannerPreview && (
//                                     <Box mt={2}>
//                                         <Typography variant="body2" mb={2}>Preview:</Typography>
//                                         <img src={bannerPreview} alt="Banner Preview" width="100%" />
//                                     </Box>
//                                 )}
//                             </Box>
//                         </Grid>

//                         {/* App Name and Theme Color */}
//                         <Grid item size={{ xs: 12, md: 6 }} sx={{ boxShadow: 4, p: 4 }}>
//                             <Typography variant="h6" mt={2}>Application Name</Typography>
//                             <Field
//                                 as={TextField}
//                                 name="appName"
//                                 fullWidth
//                                 variant="outlined"
//                                 placeholder="Enter app name"
//                                 sx={{ mt: 2 }}
//                             />
//                             <Typography variant="h6" mt={4}>Select Theme Color</Typography>
//                             <Box mt={2}>
//                                 <SketchPicker
//                                     color={values.themeColor}
//                                     onChangeComplete={(color) => setFieldValue('themeColor', color.hex)}
//                                 />
//                             </Box>
//                         </Grid>

//                         {/* Save Button */}
//                         <Grid item xs={12}>
//                             <Button
//                                 variant="contained"
//                                 color="primary"
//                                 type="submit"
//                                 sx={{ mt: 4 }}
//                             >
//                                 Save Settings
//                             </Button>
//                         </Grid>
//                     </Grid>
//                 </Form>
//             )}
//         </Formik>
//     </Box>
// );
// };

// export default BrandingSettings;



// --------------------------------------------


import {
    Box,
    Typography,
    Button,
    TextField,
    Grid,
} from '@mui/material';
import { useEffect, useState } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { SketchPicker } from 'react-color';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import actions from '../../ReduxStore/actions';
import { adminUrl } from '../../constants';
import { toast, ToastContainer } from 'react-toastify';

const BrandingSettings = () => {
    const dispatch = useDispatch();

    const { getSiteSettings } = useSelector(
        (state) => state?.getSiteSettings
    );
    const [logoPreview, setLogoPreview] = useState(null);
    const [faviconPreview, setFaviconPreview] = useState(null);
    const [bannerPreview, setBannerPreview] = useState(null);
    const [initialValues, setInitialValues] = useState({
        logo: '',
        favicon: '',
        banner: '',
        themeColor: '#1976d2',
        appName: ''
    });


    console.log(logoPreview, "logoPreviewlogoPreview")
    // useEffect(() => {
    //     dispatch(actions.GETSITESETTINGS()); // assuming you have this action to load settings
    // }, [dispatch]);

    useEffect(() => {
        if (getSiteSettings) {
            const logoUrl = getSiteSettings?.data?.logo || '';
            const faviconUrl = getSiteSettings?.data?.favicon || '';
            const bannerUrl = getSiteSettings?.data?.banner_image || '';
            console.log(logoUrl, "logoUrl")

            setInitialValues({
                logo: logoUrl,
                favicon: faviconUrl,
                banner: bannerUrl,
                themeColor: getSiteSettings?.data?.primary_color || '#1976d2',
                appName: getSiteSettings?.data?.company_name || ''
            });

            if (logoUrl) setLogoPreview(`${adminUrl}${logoUrl}`);
            if (faviconUrl) setFaviconPreview(`${adminUrl}${faviconUrl}`);
            if (bannerUrl) setBannerPreview(`${adminUrl}${bannerUrl}`);
        }
    }, [getSiteSettings]);

    const handleFileChange = async (event, setFieldValue, fieldName, setPreview) => {
        const file = event.currentTarget.files[0];
        if (file) {
            const formData = new FormData();
            formData.append("uploadImage", file);

            const data1 = {
                data: formData,
                method: "post",
                apiName: "uploadImage",
            };

            try {
                const response = await dispatch(actions.UPLOADIMAGE(data1));
                const fileUrl = response?.payload?.data?.imageUrl;
                setFieldValue(fieldName, fileUrl);
                setPreview(`${adminUrl}${fileUrl}`);
            } catch (error) {
                console.error("Upload failed:", error);
            }
        }
    };

    const handleSubmit = async (values, { resetForm }) => {
        const data1 = {
            data: {
                primary_color: values?.themeColor,
                logo: values?.logo,
                favicon: values?.favicon,
                banner_image: values?.banner,
                company_name: values?.appName
            },
            method: "post",
            apiName: `saveSiteSettings`
        };
        const response = await dispatch(actions.SAVESITESETINGS(data1));
        if (response?.payload?.message === "Site settings saved successfully.") {
            toast.success('Site settings saved successfully.');
            setTimeout(() => {
                resetForm();
            }, 1500);
        } else {
            toast.error(response?.payload?.message);
        }
    };
    return (
        <Box sx={{ p: 6 }}>
            <Formik
                // initialValues={{
                //     logo: '',
                //     favicon: '',
                //     banner: '',
                //     themeColor: '#1976d2',
                //     appName: ''
                // }}
                // onSubmit={handleSubmit}

                enableReinitialize
                initialValues={initialValues}
                onSubmit={handleSubmit}
            >
                {({ values, setFieldValue }) => (
                    <Form>
                        <Grid container spacing={2} sx={{ border: "1px solid lightgray" }}>

                            {/* Logo Upload */}
                            <Grid item size={{ xs: 12, md: 6 }} sx={{ boxShadow: 4, p: 4 }}>
                                <Typography variant="h6" align="center" mb={2}>Upload Logo <span style={{ fontSize: "14px", color: "gray" }}> (.png only) </span></Typography>
                                <Box display="flex" flexDirection="column" alignItems="center">
                                    <Button
                                        component="label"
                                        variant="outlined"
                                        sx={{
                                            py: 4,
                                            px: 6,
                                            borderRadius: 2,
                                            borderStyle: 'dashed',
                                            borderColor: 'gray',
                                            bgcolor: '#fff',
                                            cursor: 'pointer',
                                            textTransform: 'none',
                                            '&:hover': {
                                                borderColor: 'primary.main',
                                                bgcolor: '#f0f0f0',
                                            },
                                        }}
                                    >
                                        <CloudUploadIcon sx={{ fontSize: 80, color: "var(--main-color)" }} />
                                        <input
                                            type="file"
                                            accept=".png"
                                            hidden
                                            onChange={(e) =>
                                                handleFileChange(e, setFieldValue, 'logo', setLogoPreview)
                                            }
                                        />
                                    </Button>
                                    {logoPreview && (
                                        <Box mt={2}>
                                            <Typography variant="body2" mb={2}>Preview:</Typography>
                                            <img src={logoPreview} alt="Logo Preview" width="100" />
                                        </Box>
                                    )}
                                </Box>
                            </Grid>

                            {/* Favicon Upload */}
                            <Grid item size={{ xs: 12, md: 6 }} sx={{ boxShadow: 4, p: 4 }}>
                                <Typography variant="h6" align="center" mb={2}>Upload Favicon <span style={{ fontSize: "14px", color: "gray" }}>(.ico only)</span></Typography>
                                <Box display="flex" flexDirection="column" alignItems="center">
                                    <Button
                                        component="label"
                                        variant="outlined"
                                        sx={{
                                            py: 4,
                                            px: 6,
                                            borderRadius: 2,
                                            borderStyle: 'dashed',
                                            borderColor: 'gray',
                                            bgcolor: '#fff',
                                            cursor: 'pointer',
                                            textTransform: 'none',
                                            '&:hover': {
                                                borderColor: 'color:"var(--main-color)"',
                                                bgcolor: '#f0f0f0',
                                            },
                                        }}
                                    >
                                        <CloudUploadIcon sx={{ fontSize: 80, color: "var(--main-color)" }} />
                                        <input
                                            type="file"
                                            accept=".ico"
                                            hidden
                                            onChange={(e) =>
                                                handleFileChange(e, setFieldValue, 'favicon', setFaviconPreview)
                                            }
                                        />
                                    </Button>
                                    {faviconPreview && (
                                        <Box mt={2}>
                                            <Typography variant="body2" mb={2}>Preview:</Typography>
                                            <img src={faviconPreview} alt="Favicon Preview" width="32" height="32" />
                                        </Box>
                                    )}
                                </Box>
                            </Grid>

                            {/* Banner Upload */}
                            <Grid item size={{ xs: 12, md: 6 }} sx={{ boxShadow: 4, p: 4 }}>
                                <Typography variant="h6" align="center" mb={2}>Upload Banner <span style={{ fontSize: "14px", color: "gray" }}> (jpeg, jpg, png) </span></Typography>
                                <Box display="flex" flexDirection="column" alignItems="center">
                                    <Button
                                        component="label"
                                        variant="outlined"
                                        sx={{
                                            py: 4,
                                            px: 6,
                                            borderRadius: 2,
                                            borderStyle: 'dashed',
                                            borderColor: 'gray',
                                            bgcolor: '#fff',
                                            cursor: 'pointer',
                                            textTransform: 'none',
                                            '&:hover': {
                                                borderColor: 'primary.main',
                                                bgcolor: '#f0f0f0',
                                            },
                                        }}
                                    >
                                        <CloudUploadIcon sx={{ fontSize: 80, color: "var(--main-color)" }} />
                                        <input
                                            type="file"
                                            accept=".jpeg,.jpg,.png"
                                            hidden
                                            onChange={(e) =>
                                                handleFileChange(e, setFieldValue, 'banner', setBannerPreview)
                                            }
                                        />
                                    </Button>
                                    {bannerPreview && (
                                        <Box mt={2}>
                                            <Typography variant="body2" mb={2}>Preview:</Typography>
                                            <img src={bannerPreview} alt="Banner Preview" width="100%" />
                                        </Box>
                                    )}
                                </Box>
                            </Grid>

                            {/* App Name and Theme Color */}
                            <Grid item size={{ xs: 12, md: 6 }} sx={{ boxShadow: 4, p: 4 }}>
                                <Typography variant="h6" mt={2}>Application Name</Typography>
                                <Field
                                    as={TextField}
                                    name="appName"
                                    fullWidth
                                    variant="outlined"
                                    placeholder="Enter app name"
                                    sx={{ mt: 2 }}
                                />
                                <Typography variant="h6" mt={4}>Select Theme Color</Typography>
                                <Box mt={2}>
                                    <SketchPicker
                                        color={values.themeColor}
                                        onChangeComplete={(color) => setFieldValue('themeColor', color.hex)}
                                    />
                                </Box>
                            </Grid>

                            {/* Save Button */}
                            <Grid item size={{ xs: 12 }} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Button
                                    variant="contained"
                                    // color="primary"
                                    sx={{ mt: 4, background: "var(--main-color)", color: "white", mb: 2, textTransform: "none" }}
                                    type="submit"
                                >
                                    Save Settings
                                </Button>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
            <ToastContainer
                    position="top-right"
                    autoClose={1500}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="dark"
                  />
        </Box >
    );
};

export default BrandingSettings;
